import React, { useEffect, useRef, useState } from "react";
import './DepositMain.css'
import { useNavigate, useSearchParams } from "react-router-dom";
import { toPng } from "html-to-image";
import UPIPage from "./UPIPage";
import NeftPage from "./NeftPage";
import { compressImage } from "../../Services/ImageCompressor";

const DepositMain = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [orderDetails, setOrderDetails] = useState({})
    const countIntervalId = useRef()
    const pollIntervalId = useRef()
    const [baseurl, setURL] = useState(window.location.origin)
    // const [baseurl, setURL] = useState('http://10.10.20.2:9990')
    const pollInterval = 3000;
    const [endTime, setEndTime] = useState()
    const [config, setConfig] = useState()
    const [redirectLinks, setRedirect] = useState()
    const qrRef = useRef()
    const [ispaid, setIsPaid] = useState(false)
    const [showMobile, setShowMobile] = useState(false)
    const remainingTimeInSeconds = useRef()
    const [utrToShow, setUtrShow] = useState()
    const [fileValue, setFileValue] = useState("")
    const [paymentImg, setPaymentImg] = useState()
    const [currency, setCurrency] = useState("")
    const [image, setImage] = useState("")
    const [errMsg, setError] = useState("")

    useEffect(() => {
        window.onbeforeunload = function () {
            return "Are you sure you want to navigate away?";
        }
        window.onresize = function () {
            if (window.innerWidth <= 480 && !showMobile) {
                setShowMobile(true)
            }
            if (window.innerWidth > 480 && showMobile) {
                setShowMobile(false)
            }
        }
        return clearInterval(pollIntervalId.current)
    }, [])

    useEffect(() => {
        let upiObj = {};
        if (searchParams.size) {
            for (const entry of searchParams.entries()) {
                upiObj[entry[0]] = entry[1]
            }
            setOrderDetails({ ...upiObj })
            // fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/merchant-urls-info?orderId=${upiObj.transactionId}`, { method: "POST" }).then(res => res.json()).then((res) => {
            fetch(`${baseurl}/pay/transaction/merchant-urls-info?orderId=${upiObj.transactionId}`, { method: "POST" }).then(res => res.json()).then((res) => {
                if (res?.message === "Merchant Not Found") {
                    clearInterval(pollIntervalId.current);
                    clearInterval(countIntervalId.current);
                    navigate(`/cancel?orderId=${upiObj?.transactionId}`, { replace: true, state: redirectLinks?.failedRedirectionURL })
                }
                if (res.data.transactionStatus == "INITIATED") {
                    setUtrShow(res?.data?.utrToShow)
                    setEndTime(new Date().getTime() + (res?.data?.remainingTimeInSeconds * 1000))
                    remainingTimeInSeconds.current = res?.data?.remainingTimeInSeconds
                    setOrderDetails((prev) => ({ ...prev, amount: res?.data?.transactionAmount, upiId: res?.data?.transactionUpiId }))
                    setRedirect({ ...res?.data })
                    setCurrency(res?.data?.currency)
                }
                if (res.data.transactionStatus == "CANCELLED") {
                    clearInterval(pollIntervalId.current);
                    clearInterval(countIntervalId.current)
                    navigate(`/cancel?orderId=${upiObj?.transactionId}`, { replace: true, state: redirectLinks?.failedRedirectionURL })
                }
                if (res.data.transactionStatus == "PENDING_CONFIRMATION") {
                    clearInterval(pollIntervalId.current);
                    clearInterval(countIntervalId.current)
                    navigate(`/pending-confirmation?orderId=${upiObj?.orderId}&transactionId=${upiObj?.transactionId}&merchantId=${orderDetails.merchantId}`, { replace: true, state: res?.data?.pendingRedirectionURL })
                }
                if (res.data.transactionStatus == "CONFIRMED") {
                    clearInterval(pollIntervalId.current);
                    clearInterval(countIntervalId.current)
                    navigate(`/success?orderId=${upiObj?.orderId}&transactionId=${upiObj?.transactionId}`, { replace: true, state: res?.data?.pendingRedirectionURL })
                }
            }).catch((res) => {

            })
        }
    }, [searchParams])

    useEffect(() => {
        if (endTime) {
            clearInterval(countIntervalId.current)
            countIntervalId.current = setInterval(updateCountdown, 1000)
        }
    }, [endTime])

    useEffect(() => {
        if (orderDetails) {
            if (orderDetails?.traderUpiMerchantId == 0) {
                setConfig(`upi://pay?pa=${orderDetails?.upiId}&cu=INR&am=${orderDetails?.amount}&tn=${orderDetails?.transactionId}`)
            } else {
                setConfig(`upi://pay?pa=${orderDetails?.upiId}&cu=INR&am=${orderDetails?.amount}&tn=${orderDetails?.transactionId}&mc=${orderDetails?.traderUpiMerchantId}`)
            }
            clearInterval(pollIntervalId?.current)
            pollIntervalId.current = setInterval(pollForStatus, pollInterval)
        }

    }, [orderDetails])


    // async function generateHash(secretKey, formData) {
    //  //  console.log("SECre",secretKey);
        
    //     let queryString = "";
    //     const sortedParams = [];
    
    //     // Iterate over FormData to construct key-value pairs
    //     for (let [key, value] of formData.entries()) {
    //         if (value !== null && value !== undefined && value !== "" && key !=='paymentProof') {
    //             sortedParams.push(`${key}=${value}`);
    //         }
    //     }
    
    //     // Sort and join for consistent hashing
    //     sortedParams.sort();
    //     queryString = sortedParams.join("&");
    
    //  //  console.log("Message to be hashed:", queryString); // Debugging step
    
    //     // Encode key and message
    //     const encoder = new TextEncoder();
    //     const keyData = encoder.encode(secretKey);
    //     const messageData = encoder.encode(queryString);
    
    //     // Import key for HMAC
    //     const cryptoKey = await window.crypto.subtle.importKey(
    //         "raw",
    //         keyData,
    //         { name: "HMAC", hash: { name: "SHA-256" } },
    //         false,
    //         ["sign"]
    //     );
    
    //     // Generate HMAC
    //     const signature = await window.crypto.subtle.sign("HMAC", cryptoKey, messageData);
    
    //     // Convert ArrayBuffer to hex string
    //     const hashArray = Array.from(new Uint8Array(signature));
    //     const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
    
    //     return hashHex;
    // }


    function cancelButton() {
        if (window.confirm("Are You sure to Cancel the Transaction?")) {
            clearInterval(pollIntervalId.current);
            clearInterval(countIntervalId.current)
            // fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/payer/cancel-order?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`, { method: 'GET' }).then((res) => res.json()).then((res) => {
            fetch(`${baseurl}/pay/transaction/payer/cancel-order?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`, { method: 'GET' }).then((res) => res.json()).then((res) => {
                if (res?.success)
                    navigate(`/cancel?orderId=${orderDetails?.transactionId}`, { replace: true, state: redirectLinks?.failedRedirectionURL })
            }).catch((res) => { })
        }
    }

    function redirectToPaymentApp() {
        window.location.href = config;
    }

    async function pendingConfirmation() {

        clearInterval(pollIntervalId.current)
        clearInterval(countIntervalId.current)
        const formdata = new FormData()
        formdata.append("orderId", orderDetails?.orderId)
        formdata.append("merchantId", orderDetails?.merchantId)
        formdata.append("transactionId", orderDetails?.transactionId)
        orderDetails?.utr && formdata.append("utr", orderDetails?.utr)
        paymentImg && formdata.append("paymentProof", paymentImg)

        // fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/payer/confirm-order`, { method: 'POST', body: formdata }).then((res) => res.json()).then((res) => {
        // let dataRes = await fetch("/Details.json").then(res => res.json())
     //  console.log(dataRes.find(ele => ele.merchantId === orderDetails.merchantId),);
        // let queryString = '';
        // const sortedParams = [];
        // for (const [key, value] of formdata.entries()) {
        //     if (value !== null && value !== "") {
        //         sortedParams.push(`${key}=${value}`);
        //     }
        // }
     //  console.log(sortedParams);

        // sortedParams.sort();
        // queryString = sortedParams.join('&');
     //  console.log('Query string:', queryString);
     //  console.log(orderDetails,dataRes,dataRes.find(ele => ele.merchantId === orderDetails.merchantId));
        fetch(`${baseurl}/pay/transaction/payer/confirm-order`, {
            method: 'POST', 
            // headers: {
                
            //     "Signature":await generateHash(dataRes.find(ele => ele.merchantId === orderDetails.merchantId).secretKey, formdata)
            // }, 
            body: formdata
        }).then((res) => res.json()).then((res) => {
            if (res?.success) {
                res?.message == "pending" && navigate(`/pending-confirmation?orderId=${orderDetails?.orderId}&transactionId=${orderDetails?.transactionId}&merchantId=${orderDetails?.merchantId}`, { replace: true, state: orderDetails?.pendingRedirectionURL })
                res?.message == "deposit-success" && navigate(`${orderDetails.successRedirectionURL}`, { replace: true })
                res?.message == "deposit-fail" && navigate(`/failed?orderId=${orderDetails?.orderId}&transactionId=${orderDetails?.transactionId}`, { replace: true, state: orderDetails?.pendingRedirectionURL })
            } else {
                setFileValue("")
                setImage("")
                setPaymentImg("")
                setError(res?.message)
            }
        }).catch((res) => { })
    }

    async function updateCountdown() {
        const now = new Date().getTime();
        const timeLeft = endTime - now;
        if (timeLeft <= 1) {
            clearInterval(countIntervalId.current);

            localStorage.removeItem("transactionEndTime");
            localStorage.removeItem("orderId");

            clearInterval(pollIntervalId.current)
            // fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/payer/timed-out?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`, { method: 'GET' }).then((res) => res.json()).then((res) => {
            fetch(`${baseurl}/pay/transaction/payer/timed-out?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`, { method: 'GET' }).then((res) => res.json()).then((res) => {
                if (res?.success)
                    navigate(`/timed-out?orderId=${orderDetails?.transactionId}`, { replace: true, state: redirectLinks?.failedRedirectionURL })
            }).catch((res) => {

            })

        } else {
            const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
            document.getElementById("countdown").innerText = `${minutes <= 9 ? ('0' + minutes) : minutes}:${seconds <= 9 ? ('0' + seconds) : seconds}`;
            if ((minutes * 60) + seconds <= utrToShow) {
                if (window.innerWidth > 480) {
                    setIsPaid(true)
                }
            }
        }
    }

    async function pollForStatus() {
        if (orderDetails?.orderId) {

            try {
                // const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/pollForStatus?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`, { method: 'GET' }).catch((res) => { });
                const response = await fetch(`${baseurl}/pay/transaction/pollForStatus?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`, { method: 'GET' }).catch((res) => { });
                if (response.ok) {
                    const result = await response.json(); // Assuming JSON response
                    if (result.message === 'TIME_EXCEEDED') {
                        document.getElementById('utrError').style.display = "block";

                        if (window.innerWidth > 480) {
                            setIsPaid(true)
                        }

                    }
                    if (result.message === 'SUCCESS') { // Check success condition
                        clearInterval(pollIntervalId.current); // Stop polling
                        clearInterval(countIntervalId.current); // Stop polling
                        navigate(`/success?orderId=${orderDetails?.orderId}&transactionId=${orderDetails?.transactionId}`, { replace: true, state: redirectLinks?.pendingRedirectionURL })
                    }
                    if (result.message === 'CANCELLED') { // Check success condition
                        clearInterval(pollIntervalId.current); // Stop polling
                        clearInterval(countIntervalId.current); // Stop polling
                        navigate(`/cancel?orderId=${orderDetails?.transactionId}`, { replace: true, state: redirectLinks?.failedRedirectionURL })
                    }
                } else {

                }
            } catch (error) {
            }
        }
    }

    const handleDownload = () => {
        if (qrRef.current) {
            toPng(qrRef.current) // Convert QR code to PNG image
                .then((dataUrl) => {
                    const link = document.createElement('a');
                    link.href = dataUrl;
                    link.download = 'qr-code.png'; // File name for download
                    link.click(); // Trigger download
                })
                .catch((err) => {
                });
        }
    };

    const openWithSelectedApps = (e) => {
        let newUrl;
        if (e.currentTarget.id != "tez") {
            newUrl = e.currentTarget.id + config.slice(3)
        }
        else {
            newUrl = e.currentTarget.id + "://upi/" + config.slice(6)
        }

        window.location.href = newUrl
    }

    const showUTRNumber = (value) => {
        setIsPaid(value)
    }

    const getBase64 = async (e) => {
        // console.dir(e);
        if (e.target.value) {

            let selected = document.getElementById(e.target.id).files;
            if (selected.length > 0) {
                var fileToLoad = selected[0];
                if (fileToLoad.size / 1024 <= 250) {

                    var fileReader = new FileReader();
                    setPaymentImg(fileToLoad)

                    fileReader.onload = function (fileLoadedEvent) {
                        var srcData = fileLoadedEvent.target.result; // <--- data: base64

                        // setPaymentImg(srcData.slice(srcData.indexOf(',') + 1))
                        setImage(srcData.slice(srcData.indexOf(',') + 1))
                    }
                    fileReader.readAsDataURL(fileToLoad);
                }
                else {
                    const compressedBlob = await compressImage(fileToLoad);
                    setPaymentImg(compressedBlob)
                    const base64URL = await blobToBase64(compressedBlob);
                    setImage(base64URL.replace(/^data:image\/[^;]+;base64,/, ''))
                }
            }
            setError("")
        } else {
            setPaymentImg("")
        }
    }

    function blobToBase64(blob) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => resolve(reader.result);
        });
    }

    function copyToClipboard(text) {
        let copyText = text
        if (copyText && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(copyText)
                .then(() => {
                })
                .catch(err => {
                });
        } else {
            fallbackCopy(copyText);
        }
    }

    function fallbackCopy(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed'; // Avoid scrolling
        textArea.style.top = '0';
        textArea.style.left = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            const successful = document.execCommand('copy');
            if (successful) {
            } else {
            }
        } catch (err) {
        }
        document.body.removeChild(textArea);
    }

    const removeImg = () => {
        setImage("")
        setFileValue("")
        setPaymentImg("")
    }

    const togglePreview = () => {
        document.querySelector(".preview_Image").classList.toggle("show_preview")
    }

    return <>
        <div className="preview_Image" onClick={(e) => { e.currentTarget === e.target && togglePreview() }}>
            <img src={'data:image/png;base64,' + image} alt="" />
        </div>
        {["UPI", "IPAY"].includes(orderDetails?.transactionInstrument) ? <UPIPage paymentImg={paymentImg}
            orderDetails={orderDetails}
            pendingConfirmation={pendingConfirmation}
            config={config}
            ispaid={ispaid}
            currency={currency}
            qrRef={qrRef}
            redirectLinks={redirectLinks}
            showUTRNumber={showUTRNumber}
            redirectToPaymentApp={redirectToPaymentApp}
            openWithSelectedApps={openWithSelectedApps}
            setOrderDetails={setOrderDetails}
            getBase64={getBase64}
            fileValue={fileValue}
            setFileValue={setFileValue}
            cancelButton={cancelButton}
            image={image}
            removeImg={removeImg}
            togglePreview={togglePreview}
            errMsg={errMsg}
        ></UPIPage> : <NeftPage paymentImg={paymentImg}
            orderDetails={orderDetails}
            pendingConfirmation={pendingConfirmation}
            config={config}
            ispaid={ispaid}
            currency={currency}
            qrRef={qrRef}
            redirectLinks={redirectLinks}
            showUTRNumber={showUTRNumber}
            redirectToPaymentApp={redirectToPaymentApp}
            openWithSelectedApps={openWithSelectedApps}
            setOrderDetails={setOrderDetails}
            getBase64={getBase64}
            fileValue={fileValue}
            setFileValue={setFileValue}
            cancelButton={cancelButton}
            copyToClipboard={copyToClipboard}
            image={image}
            removeImg={removeImg}
            togglePreview={togglePreview}
            errMsg={errMsg}
        ></NeftPage>}
    </>
}

export default DepositMain